// lib/services/resource/mesh_resource.ts
import {Resource,ResourceLoadContext} from "./resource"
import { ModelData } from "../geometry/modeldata";
import GlbLoader from "./glb_loader";

type ModelProcessor = (key: string, model: ModelData) => ModelData;
const modelProcessors = new Map<string, ModelProcessor>();
/** Register application-level import policies before requesting mesh resources. */
export function registerMeshModelProcessor(name: string, processor: ModelProcessor): void {
  modelProcessors.set(name, processor);
}
export function processMeshModel(key: string, model: ModelData): ModelData {
  for (const processor of modelProcessors.values()) model = processor(key, model);
  return model;
}

export default class MeshResource extends Resource<ModelData> {
  async load(ctx: ResourceLoadContext): Promise<ModelData> {
    const response = await ctx.fetchPrivate(this.key);
    if (!response.ok) {
      throw new Error(`Failed to load mesh: ${this.key}`);
    }

    const bytes = await response.arrayBuffer();
    const loader = new GlbLoader();
    const model = processMeshModel(this.key, await loader.load(bytes));

    this._value = model;
    return model;
  }

  dispose(_ctx: ResourceLoadContext): void {
      this._value = undefined;
   
  }
}
